function u(n) {
  const s = n.split(":").map(Number);
  switch (s.length) {
    case 2: {
      const [t, e] = s;
      return { hours: t, minutes: e };
    }
    case 3: {
      const [t, e, r] = s;
      return { hours: t, minutes: e, seconds: r };
    }
  }
  return { hours: 0, minutes: 0 };
}
export {
  u as default
};
